"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeMapOfSets = serializeMapOfSets;
exports.deserializeMapOfSets = deserializeMapOfSets;
/**
 * Helper functions for serializing and deserializing complex objects like Map and Set
 * that don't maintain their type when stored in VS Code's extension state (Memento)
 */
/**
 * Converts a Map with Set values to a serializable object
 * @param map The Map of Sets to serialize
 * @returns A plain object representation of the Map of Sets
 */
function serializeMapOfSets(map) {
    const obj = {};
    for (const [key, value] of map.entries()) {
        obj[key.toString()] = Array.from(value);
    }
    return obj;
}
/**
 * Converts a serialized Map of Sets back to a Map instance with Set values
 * @param obj The plain object representation of a Map of Sets
 * @returns A new Map instance with Set values
 */
function deserializeMapOfSets(obj) {
    const map = new Map();
    if (!obj) {
        return map;
    }
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const sanitizedValues = (obj[key] || []).filter((value) => value !== undefined && value !== null);
            const set = new Set(sanitizedValues);
            // Cast the key to K - this is safe if K is string | number
            map.set(key, set);
        }
    }
    return map;
}
//# sourceMappingURL=SerializationHelpers.js.map